/**
 * SettingsNav — sidebar (≥768px) / accordion-style chip row (<768px) for the
 * /settings page. The current section is highlighted; clicking a section
 * fires `onSelect(section)` to update the page-level active section.
 *
 * Sections that the current user cannot access are filtered out before
 * rendering (e.g. Company is admin-only).
 */
const ALL_SECTIONS = [
  { key: 'profile', label: 'Profile', adminOnly: false },
  { key: 'company', label: 'Company', adminOnly: true },
  { key: 'security', label: 'Security', adminOnly: false },
  { key: 'branding', label: 'Branding', adminOnly: true },
  { key: 'danger', label: 'Danger Zone', adminOnly: false },
];

export function SettingsNav({ active, onSelect, isAdmin }) {
  const sections = ALL_SECTIONS.filter((s) => !s.adminOnly || isAdmin);
  return (
    <nav className="settings-nav" aria-label="Settings sections">
      <ul className="settings-nav-list">
        {sections.map((s) => (
          <li key={s.key}>
            <button
              type="button"
              className={`settings-nav-link${active === s.key ? ' is-active' : ''}`}
              aria-current={active === s.key ? 'page' : undefined}
              onClick={() => onSelect(s.key)}
            >
              {s.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
